import { useEffect, useState } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IWarehouse } from '@/types/fulfill/warehouse/warehouse.interface';

interface UseWarehousesReturn {
  warehouses: IWarehouse[];
  warehouseOptions: { value: string; label: string }[];
  isLoading: boolean;
  error: string | null;
}

export const useWarehouses = (): UseWarehousesReturn => {
  const [warehouses, setWarehouses] = useState<IWarehouse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        setIsLoading(true);
        const http = initializeHttpProvider();
        const response = await http.warehouses.getWarehouses();

        if (response.success) {
          setWarehouses(response.data);
          setError(null);
        } else {
          setError(response.message || 'Error al obtener los almacenes');
        }
      } catch (err) {
        console.error('Error fetching warehouses:', err);
        setError('Error al cargar los almacenes');
      } finally {
        setIsLoading(false);
      }
    };

    fetchWarehouses();
  }, []);

  const warehouseOptions = warehouses.map((warehouse) => ({
    value: warehouse._id,
    label: warehouse.name,
  }));

  return {
    warehouses,
    warehouseOptions,
    isLoading,
    error,
  };
};
